import angular from "angular";

let HomeVideoController = function (
  $filter,
  $mdDialog,
  $scope,
  $state,
  $timeout,
  Video,
  Toast
) {
  let $ctrl = this;
  angular.extend($ctrl, {});

  $ctrl.filter = {
    description: "",
    page: 1,
    total: 0,
  };

  $ctrl.loadData = function () {
    Video.getList($ctrl.filter)
      .then((response) => {
        $ctrl.resources = angular.copy(response);
        $ctrl.filter.page = response.page;
        $ctrl.filter.total = response.total;
        $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
      })
      .catch((err) => {
        console.log(err);
        $ctrl.uiState = "ERROR";
      });
  };

  $ctrl.getRegions = function (regionsList) {
    let newList = [];
    regionsList.forEach((item) => {
      if (!item.regions.length) {
        newList.push(item.state);
        return;
      }
      item.regions.forEach((region) => {
        newList.push(`${region.name} - ${item.state}`);
      });
    });
    return newList.join(", ");
  };

  $ctrl.onChangeFilter = function () {
    $ctrl.filter.page = 1;
    $ctrl.loadData();
  };

  function activate() {
    $ctrl.loadData();
  }

  $ctrl.deleteVideo = function (item) {
    let confirm = $mdDialog
      .confirm()
      .textContent(`Remover video "${item.description}"`)
      .ariaLabel(`Remover pop-up "${item.description}"`)
      .targetEvent(event)
      .ok($filter("translate")("common-yes"))
      .cancel($filter("translate")("common-cancel"));

    $mdDialog
      .show(confirm)
      .then(() => {
        Video.destroy(item)
          .then((response) => {
            Toast.success($filter("translate")("common-detail-delete-success"));
            $ctrl.loadData();
          })
          .catch((err) => {
            Toast.error($filter("translate")("common-server-error"));
          });
      })
      .catch(() => {});
  };

  $ctrl.detail = function (id) {
    $state.go("page.view-video-home", { id });
  };

  activate();
};

HomeVideoController.$inject = [
  "$filter",
  "$mdDialog",
  "$scope",
  "$state",
  "$timeout",
  "Video",
  "Toast",
];

export default HomeVideoController;



// WEBPACK FOOTER //
// ./client/app/components/page/page-home-video.controller.js